<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="描述" prop="name">
      <el-input v-model="dataForm.name" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="图片" prop="img">
      <el-input v-model="dataForm.img" placeholder=""></el-input>
      <input id="fileSelector"
               type="file"
               @change="guanggaoimg" />
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import COS from 'cos-js-sdk-v5'
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          name: '',
          img: '',
          addtime: ''
        },
        dataRule: {
          name: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          img: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      guid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line one-var
        var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
      guanggaoimg (e) {
      var _this = this
      const file = e.target.files && e.target.files[0]
      /* 直接调用 cos sdk 的方法 */
      var cos = new COS({
        SecretId: 'AKID4zkFYr00sXyB93mEajgroVxADRaZRBHI',
        SecretKey: '2eCtUxHVba2QfliWBodOyLUZZZR87wc5'
      })
      cos.sliceUploadFile({
        Bucket: 'yunjixie-1317685697', /* 填写自己的 bucket，必须字段 */
        Region: 'ap-beijing', /* 存储桶所在地域，必须字段 */
        Key: _this.guid(), /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
        Body: file // 上传文件对象
      }, function (err, data) {
        if (err != null) {
        } else if (data != null) {
          var pingzheng = 'https://' + data.Location
          console.log(pingzheng)
          _this.$message({
            message: '上传成功',
            type: 'success'
          })
          _this.dataForm.img = pingzheng
        }
      })
    },
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.global.apiUrl  +  `/jisu/jgchengdan/info/${this.dataForm.id}`,
              method: 'get',
              params: this.$http.adornParams()
            }).then((data) => {
              data=data.body
              if (data && data.code === 0) {
                this.dataForm.name = data.jgchengdan.name
                this.dataForm.img = data.jgchengdan.img
                this.dataForm.addtime = data.jgchengdan.addtime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.global.apiUrl  +  `/jisu/jgchengdan/${!this.dataForm.id ? 'save' : 'update'}`,
              method: 'post',
              params: {
                'id': this.dataForm.id || undefined,
                'name': this.dataForm.name,
                'img': this.dataForm.img,
                'addtime': this.dataForm.addtime
              }
            }).then((data) => {
              data=data.body
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/jgchengdan-add-or-update.vue